import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-customer-apk-version',
  templateUrl: './customer-apk-version.component.html',
  styleUrls: ['./customer-apk-version.component.css']
})
export class CustomerAPKVersionComponent implements OnInit {

  objectForm: any | FormGroup;
  allCustomer: any= []
  singleAPK: any = []
  page: number = 1;
  count: number = 0;
  first: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  isLoading: any = false
  CustomerAPKId: any

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = sessionStorage.getItem('cid')
    this.getAllCustomerAPK()
    this.objectForm = this.fb.group({
      description:[''],
      keyValueList:this.fb.array([])
    }) 
    this.addkeyValue()
  }

  onTableDataChange(event: any) {
    this.page = event.page+1;
  }

  get objectArr(){
    return this.objectForm.get('keyValueList') as FormArray;
  }

  keyValueList(){
    return this.fb.group({
      "key": [''],
      "value": ['']
    })
  }
  
  addkeyValue(){
  this.objectArr.push(this.keyValueList())
  }

  removekeyValue(index: number){
  this.objectArr.removeAt(index)
  }

  addCustomerAPK(){
    let body = 
    {
      "version": 0,
      "isActive": true,
      "description": String(this.objectForm.get('description').value),
      "id": 0,
      "keyValueList": this.objectForm.get('keyValueList').value,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.addCustomerAPK(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.objectForm.reset()
        this.getAllCustomerAPK()
        this.toastr.success(response.message)
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllCustomerAPK(){
    this.isLoading = true

    this.generic_service.getAllCustomerAPK().subscribe(
      (response:any)=>{
        console.log(response)
        this.allCustomer = response.response
        this.count = response.response.length
        this.isLoading = false

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton5")?.click()

  }

  getCustomerAPKById(id:any){
    this.generic_service.getCustomerAPKById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleAPK = []
        this.singleAPK.push(response.response);

        this.objectForm.reset()
        this.objectArr.clear()
    
        this.objectForm.patchValue({
          description: response.response.description,
        })
        for(var i=0; i<response.response.keyValueList.length; i++){
          let obj = this.fb.group({
            "key":[response.response.keyValueList[i].key],
            "value":[response.response.keyValueList[i].value]
          })
          this.objectArr.push(obj)
        }
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  del(id:any){
    this.CustomerAPKId = id;
  }

  deleteCustomerAPK(){
    this.generic_service.deleteCustomerAPK(this.CustomerAPKId).subscribe(
      (response:any)=>{
        console.log(response);
        this.getAllCustomerAPK()
        this.toastr.success("Successfully Deleted")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  updateCustomerAPK(){
    let body = 
    {
      "version": 0,
      "isActive": true,
      "description": String(this.objectForm.get('description').value),
      "id": this.singleAPK[0].id,
      "customerAPKVersionId": this.singleAPK[0].customerAPKVersionId,
      "keyValueList": this.objectForm.get('keyValueList').value,
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateCustomerAPK(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.objectForm.reset()
        this.getAllCustomerAPK()
        this.toastr.success("Successfully Updated")
        this.cancelModel()
      },
      (error:any)=>{
        console.log(error.error.errors[0].description)
      }
    )
  }


}
